import { Switch } from '@shigo-ui/ui';

import { dashboardT } from '@/lib/messages';

/** Compact "vs previous" control for dashboard table headers; the switch keeps the full name. */
export function DashboardComparisonToggle({
  checked,
  onCheckedChange,
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}) {
  const label = dashboardT('dashboard.comparison.previousPeriod');
  return (
    <label
      title={label}
      className="text-muted-foreground bg-card border-border-strong inline-flex h-8 cursor-pointer items-center gap-2 rounded-md border px-2.5 text-xs whitespace-nowrap"
    >
      <Switch aria-label={label} checked={checked} onCheckedChange={onCheckedChange} />
      {dashboardT('dashboard.comparison.short')}
    </label>
  );
}
